const mainHeaderNavWrapper = document.querySelectorAll(".main-header-nav-wrapper");
const mainNavChildContainer = document.querySelectorAll(".main-nav-child-container");
const mainHeaderSearchMobileContainer = document.getElementById("main-header-mobile__search-container")
const mainHeaderSearchMobile = document.getElementById("main-header-mobile__search")

const mainNavHamburger = document.querySelector(".main-nav-hamburger")
const mainMobileNavContent = document.querySelector(".main-mobile-nav-content")
const mainMobileNavTitle = document.querySelectorAll(".main-mobile-nav-title")
const mainMobileNavChildContainer = document.querySelectorAll(".main-mobile-nav-child-container")
const mainMobileHeaderNavWrapper = document.querySelectorAll(".main-mobile-header-nav-wrapper")

mainHeaderSearchMobile.addEventListener("click", function () {
  mainHeaderSearchMobileContainer.style.display = mainHeaderSearchMobileContainer.style.display === "block" ? "none" : "block";
})

mainHeaderNavWrapper.forEach((title) => {
  title.addEventListener("mouseover", function () {
    title.classList.add("is-active");
  });

  title.addEventListener("mouseout", function () {
    title.classList.remove("is-active");
  });
});

mainNavHamburger.addEventListener('click', function () {
  mainMobileNavContent.style.display = mainMobileNavContent.style.display === 'none' ? 'block' : 'none';
})

mainMobileNavTitle.forEach((title) => {
  const titleIndex = title.getAttribute("data-index");

  title.addEventListener("click", function () {

    mainMobileHeaderNavWrapper.forEach((wrapper) => {
      const wrapperIndex = wrapper.getAttribute("data-index");
      if (titleIndex === wrapperIndex) {
        wrapper.classList.toggle('is-active-wrapper')
      } else {
        wrapper.classList.remove('is-active-wrapper')
      }
    })
    mainMobileNavChildContainer.forEach((child) => {
      const childIndex = child.getAttribute("data-index");

      if (titleIndex === childIndex) {
        child.style.display = child.style.display === "block" ? "none" : "block";
      } else {
        child.style.display = "none";
      }
    })
  })
})